import {Outlet} from "react-router";
import SimpleLayout from "@/components/layout/SimpleLayout.jsx";

export default function SimpleNarrowLayout() {
    return (
        <SimpleLayout>
            <Outlet/>
        </SimpleLayout>
    );
}
